import { render, staticRenderFns } from "./ListaAplicantes.vue?vue&type=template&id=6e860e77"
import script from "./ListaAplicantes.vue?vue&type=script&lang=js"
export * from "./ListaAplicantes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports